//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import Validator from '../../../services/Validator/Validator';
import {
    API_CREATE_DOCUMENT_TEMPLATE_TRANSLATION,
    API_DOCUMENT_TEMPLATE_TRANSLATION_IMAGE_UPLOAD,
    API_IS_OTHER_TRANSLATION_EXISTS,
    API_IS_URL_EXISTS,
    API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION,
    API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION_STATUS,
    GET_SINGLE_DOCUMENT_TEMPLATE_TRANSLATION,
    API_DOWNLOAD_DOCUMENT_TEMPLATE_PDF,
    API_DELETE_DOCUMENT_TEMPLATE_PDF,
} from './DocumentTemplateTranslationConstants';
import DocumentTemplateTranslationResultsPojo from './DocumentTemplateTranslationResultsPojo';
import OtherTranslationExistsResultsPojo from './OtherTranslationExistsResultsPojo';

export class DocumentTemplateTranslationService {
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async create(data: any): Promise<{ success: boolean; message: string }> {
        const {
            documentTitle,
            url,
            documentDetailUrl,
            createDocumentUrl,
            documentText,
            shortDescription,
            specialInstruction,
            documentTemplateId,
            languageId,
            folderName,
            sourceDocumentTemplateTranslationId,
            documentDetailPageInfo,
            createDocumentPageInfo,
            documentTemplatePdfContent,
            documentTemplatePreviewImages,
            showFillFormOption,
            showPdfTemplateDownloadOption,
            reviews,
            tags,
        } = data;
        try {
            this.validator.isValidString('title', documentTitle);
            this.validator.isValidString(
                'documentDetailUrl',
                documentDetailUrl,
            );
            this.validator.isValidString(
                'createDocumentUrl',
                createDocumentUrl,
            );
            this.validator.isValidString('shortDescription', shortDescription);
            if (
                sourceDocumentTemplateTranslationId === '' ||
                sourceDocumentTemplateTranslationId == null
            ) {
                this.validator.isValidString('documentText', documentText);
            }
            if (
                sourceDocumentTemplateTranslationId != '' &&
                sourceDocumentTemplateTranslationId != null
            ) {
                this.validator.validatePositiveInteger(
                    sourceDocumentTemplateTranslationId,
                );
            }

            let formData = new FormData();
            formData.append('documentTemplateId', documentTemplateId);
            formData.append('languageId', languageId);
            formData.append('title', documentTitle);
            formData.append(
                'documentDetailUrl',
                documentDetailUrl.toLowerCase(),
            );
            formData.append(
                'createDocumentUrl',
                createDocumentUrl.toLowerCase(),
            );
            formData.append('shortDescription', shortDescription);
            formData.append('documentText', documentText);
            formData.append('folderName', folderName);
            formData.append(
                'documentDetailPageInfo',
                JSON.stringify(documentDetailPageInfo),
            );
            formData.append(
                'createDocumentPageInfo',
                JSON.stringify(createDocumentPageInfo),
            );
            formData.append(
                'documentTemplatePreviewImages',
                JSON.stringify(documentTemplatePreviewImages),
            );
            if (documentTemplatePdfContent instanceof File) {
                formData.append('documentTemplatePdfContent', documentTemplatePdfContent);
            }
            if (specialInstruction && specialInstruction.trim() !== '') {
                formData.append('specialInstruction', specialInstruction.trim());
            }
            formData.append('showFillFormOption', showFillFormOption ? '1' : '0');
            formData.append('showPdfTemplateDownloadOption', showPdfTemplateDownloadOption ? '1' : '0');
            if (reviews) {
                formData.append('reviews', reviews);
            }
            if (tags) {
                formData.append('tags', tags);
            }
            if (
                sourceDocumentTemplateTranslationId != '' &&
                sourceDocumentTemplateTranslationId != null
            ) {
                formData.append(
                    'sourceDocumentTemplateTranslationId',
                    sourceDocumentTemplateTranslationId,
                );
            }
            console.log(formData, "formData");
            const httpResult = await this.httpService.postFormData(
                API_CREATE_DOCUMENT_TEMPLATE_TRANSLATION,
                formData,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async update(data: any): Promise<{ success: boolean; message: string }> {
        const {
            documentTitle,
            documentDetailUrl,
            createDocumentUrl,
            documentText,
            shortDescription,
            specialInstruction,
            documentTemplateId,
            languageId,
            documentTemplateTranslationId,
            folderName,
            sourceDocumentTemplateTranslationId,
            createDocumentPageInfo,
            documentDetailPageInfo,
            documentTemplatePdfContent,
            documentTemplatePreviewImages,
            showFillFormOption,
            showPdfTemplateDownloadOption,
            reviews,
            tags,
        } = data;

        try {
            this.validator.validatePositiveInteger(documentTemplateId);
            this.validator.validatePositiveInteger(languageId);
            this.validator.validatePositiveInteger(
                documentTemplateTranslationId,
            );
            this.validator.isValidString('title', documentTitle);
            this.validator.isValidString(
                'documentDetailUrl',
                documentDetailUrl,
            );
            this.validator.isValidString(
                'createDocumentUrl',
                createDocumentUrl,
            );
            this.validator.isValidString('shortDescription', shortDescription);
            if (
                sourceDocumentTemplateTranslationId === '' ||
                sourceDocumentTemplateTranslationId == null
            ) {
                this.validator.isValidString('documentText', documentText);
            }
            if (
                sourceDocumentTemplateTranslationId != '' &&
                sourceDocumentTemplateTranslationId != null
            ) {
                this.validator.validatePositiveInteger(
                    sourceDocumentTemplateTranslationId,
                );
            }

            let formData = new FormData();
            formData.append('documentTemplateId', documentTemplateId);
            formData.append(
                'documentTemplateTranslationId',
                documentTemplateTranslationId,
            );
            formData.append('languageId', languageId);
            formData.append('title', documentTitle);
            formData.append(
                'documentDetailUrl',
                documentDetailUrl.toLowerCase(),
            );
            formData.append(
                'createDocumentUrl',
                createDocumentUrl.toLowerCase(),
            );
            formData.append('shortDescription', shortDescription);
            formData.append('documentText', documentText);
            formData.append('folderName', folderName);
            formData.append(
                'documentDetailPageInfo',
                JSON.stringify(documentDetailPageInfo),
            );
            formData.append(
                'createDocumentPageInfo',
                JSON.stringify(createDocumentPageInfo),
            );
            formData.append(
                'documentTemplatePreviewImages',
                JSON.stringify(documentTemplatePreviewImages),
            );
            if (documentTemplatePdfContent instanceof File) {
                formData.append('documentTemplatePdfContent', documentTemplatePdfContent);
            }

            if (specialInstruction && specialInstruction.trim() !== '') {
                formData.append('specialInstruction', specialInstruction.trim());
            }
            formData.append('showFillFormOption', showFillFormOption ? '1' : '0');
            formData.append('showPdfTemplateDownloadOption', showPdfTemplateDownloadOption ? '1' : '0');
            if (reviews) {
                formData.append('reviews', reviews);
            }
            if (tags) {
                formData.append('tags', tags);
            }

            if (
                sourceDocumentTemplateTranslationId != '' &&
                sourceDocumentTemplateTranslationId != null
            ) {
                formData.append(
                    'sourceDocumentTemplateTranslationId',
                    sourceDocumentTemplateTranslationId,
                );
            }

            const httpResult = await this.httpService.postFormData(
                API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION,
                formData,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async get(data: any): Promise<DocumentTemplateTranslationResultsPojo> {
        const { documentTemplateId, languageId } = data;
        try {
            this.validator.validatePositiveInteger(documentTemplateId);
            this.validator.validatePositiveInteger(languageId);

            const httpResult = await this.httpService.get(
                GET_SINGLE_DOCUMENT_TEMPLATE_TRANSLATION(
                    documentTemplateId,
                    languageId,
                ),
                {},
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
                data: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async isOtherTranslationExists(
        data: any,
    ): Promise<OtherTranslationExistsResultsPojo> {
        const { documentTemplateId, languageId } = data;
        try {
            this.validator.validatePositiveInteger(documentTemplateId);
            this.validator.validatePositiveInteger(languageId);

            const httpResult = await this.httpService.get(
                API_IS_OTHER_TRANSLATION_EXISTS(documentTemplateId, languageId),
                {},
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
                data: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async isUrlExists(
        url: string,
    ): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.isValidString('url', url);
            const payload: any = {
                url: url.toLowerCase(),
            };

            const httpResult = await this.httpService.post(
                API_IS_URL_EXISTS,
                payload,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async delete(
        documentTemplateTranslationId: number,
        status: number,
    ): Promise<Boolean> {
        try {
            this.validator.validatePositiveInteger(
                documentTemplateTranslationId,
            );
            this.validator.validateIntegerIncludingZero(status);

            const httpResult = await this.httpService.delete(
                API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION_STATUS,
                { documentTemplateTranslationId, status },
            );
            return httpResult.data.isSuccess;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async uploadImage(
        data: any,
    ): Promise<{ success: boolean; message: string; data: any }> {
        const { folderName, type, previewImage } = data;
        try {
            this.validator.validatePositiveInteger(type);

            let formData = new FormData();
            formData.append('folderName', folderName);
            formData.append('type', type);
            formData.append('image', previewImage);

            const httpResult = await this.httpService.postFormData(
                API_DOCUMENT_TEMPLATE_TRANSLATION_IMAGE_UPLOAD,
                formData,
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
                data: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async downloadPdf(documentTemplateTranslationId: number, fileName: string): Promise<void> {
        try {
            this.validator.validatePositiveInteger(documentTemplateTranslationId);
            const response = await this.httpService.get(
                API_DOWNLOAD_DOCUMENT_TEMPLATE_PDF(documentTemplateTranslationId),
                {},
                { responseType: 'blob' }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName || `template_${documentTemplateTranslationId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async deletePdf(documentTemplateTranslationId: number): Promise<{ success: boolean; message: string }> {
        try {
            this.validator.validatePositiveInteger(documentTemplateTranslationId);
            const httpResult = await this.httpService.delete(
                API_DELETE_DOCUMENT_TEMPLATE_PDF(documentTemplateTranslationId),
                {}
            );
            return {
                success: httpResult.data.isSuccess,
                message: httpResult.data.messageForUser,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
